export default class AbstractServiceNavigationBehaviour {
    constructor() {
        this._callback = null;
        this.bindMethods = this.bindMethods.bind(this);
        this.bindMethods();
        this.init();
    }

    init() {
        this._shouldExpandValue = null;
        window.addEventListener('scroll', this.onScroll);
        this.onScroll();
    }

    bindMethods() {
        this.destroy = this.destroy.bind(this);
        this.shouldExpand = this.shouldExpand.bind(this);
        this.onScroll = this.onScroll.bind(this);
    }

    /**
     * @param {function(expand: boolean): void} cb
     */
    set callback(cb) {
        this._callback = cb;
    }

    /**
     * @return {boolean}
     */
    shouldExpand() {
        throw new Error('Method `shouldExpand` is abstract and not implemented.');
    }

    onScroll() {
        const newVal = this.shouldExpand();
        if (newVal !== this._shouldExpandValue) {
            this._shouldExpandValue = newVal;
            if (typeof this._callback === 'function') {
                this._callback(newVal);
            }
        }
    }

    destroy() {
        window.removeEventListener('scroll', this.onScroll);
    }
}